export default __webpack_public_path__ + "static/media/Sorry.cf0915d0.mp3";